import http, { API_CORE } from '../http';

export default function TenantService() {
  const getAccount = async () => {
    const response = await http(API_CORE).get('/_tenants/admin/get-account');
    return response.data;
  };

  const getPayments = async (tenantId) => {
    const response = await http(API_CORE).get('/_tenants/admin/get-payments', {
      params: { tenantId: tenantId },
    });
    return response.data;
  };

  const deleteAccount = async () => {
    return http(API_CORE).delete('/_tenants/admin/delete-account');
  };

  const connectCustomDomain = async (domain) => {
    const response = await http(API_CORE).post('/_tenants/custom-domain/connect', { domain });
    return response.data;
  };

  const getCustomDomainStatus = async () => {
    const response = await http(API_CORE).get('/_tenants/custom-domain/status');
    return response.data;
  };

  const verifyCustomDomain = async () => {
    const response = await http(API_CORE).post('/_tenants/custom-domain/verify');
    return response.data;
  };

  return {
    getAccount: getAccount,
    deleteAccount: deleteAccount,
    getPayments: getPayments,
    connectCustomDomain: connectCustomDomain,
    getCustomDomainStatus: getCustomDomainStatus,
    verifyCustomDomain: verifyCustomDomain,
  };
}
